/* CART LIMIT */
document.addEventListener("DOMContentLoaded", function () {
  let updateTimeout; 

  // ── HELPER: Get (or create) the common error container ─────────────────────
  function getErrorContainer() {
    const addToCartButton = document.querySelector(".product-form__submit");
    if (addToCartButton) {
      let container = addToCartButton.parentNode.querySelector(".cart-error-messages");
      if (!container) {
        container = document.createElement("div");
        container.className = "cart-error-messages";
        // Insert above the add-to-cart button:
        addToCartButton.parentNode.insertBefore(container, addToCartButton);
      }
      return container;
    }
    let container = document.querySelector(".cart-error-messages");
    if (!container) {
      container = document.createElement("div");
      container.className = "cart-error-messages";
      document.body.appendChild(container);
    }
    return container;
  }

  function getSelectedVariantId() {
    const variantDataElement = document.querySelector("variant-selects [data-selected-variant]");
    if (!variantDataElement) {
      console.error("Error: No variant JSON found");
      return null;
    }
    try {
      const variantJson = JSON.parse(variantDataElement.textContent.trim());
      return variantJson.id && !isNaN(Number(variantJson.id)) ? String(variantJson.id) : null;
    } catch (e) {
      console.error("Error parsing selected variant JSON", e);
      return null;
    }
  }

  function updateCartQuantity(variantId, quantity) {
    if (!variantId) {
      console.error("Cannot update cart: Missing or invalid variant ID", variantId);
      return;
    }
    
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    })
      .then(response => response.json())
      .then(data => {
        if (data.status === 'bad_request') {
          console.error("Cart update failed: ", data.message);
          return;
        }
        updateCartState();
        publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-quantity-control" });
        updateCartDrawerUI();
      })
      .catch(error => console.error("Error updating cart", error));
  }

  function updateCartDrawerUI() {
    fetch("/cart.js")
      .then(response => response.json())
      .then(cart => {
        document.querySelectorAll(".product-form__submit, .quantity__input").forEach(button => {
          button.disabled = cart.items.some(item => item.quantity >= (item.inventory_quantity || Infinity));
        });
      })
      .catch(error => console.error("Error updating cart drawer UI", error));
  }

  // ── VARIANT-LEVEL CONSTRAINTS (data-max) ─────────────────────────────────────
  function updateCartState() {
    document.querySelectorAll("quantity-input").forEach((quantityInput) => {
      const input = quantityInput.querySelector(".quantity__input");
      const minusButton = quantityInput.querySelector("button[name='minus']");
      const plusButton = quantityInput.querySelector("button[name='plus']");
      const addToCartButton = document.querySelector(".product-form__submit");

      const cartQuantity = parseInt(input.getAttribute("data-cart-quantity"), 10) || 0;
      const maxQuantity = parseInt(input.getAttribute("data-max"), 10) || Infinity;
      let variantId = input.getAttribute("data-quantity-variant-id") || getSelectedVariantId();
      input.setAttribute("max", maxQuantity);

      if (!variantId) {
        console.error("Error: Missing or invalid variant ID", variantId);
        return;
      }

      // Check if this variant is allowed to add more:
      const isAvailableToAdd = cartQuantity < maxQuantity;
      input.toggleAttribute("disabled", !isAvailableToAdd);
      plusButton.classList.toggle("disabled", !isAvailableToAdd);
      addToCartButton?.toggleAttribute("disabled", !isAvailableToAdd);

      // Update variant-level error message with the allowed limit:
      const errorContainer = getErrorContainer();
      let variantError = errorContainer.querySelector(".cart-error-message--variant");
      if (!isAvailableToAdd) {
        if (!variantError) {
          variantError = document.createElement("div");
          variantError.className = "cart-error-message cart-error-message--variant";
          errorContainer.appendChild(variantError);
        }
        variantError.textContent = `Maximum allowed variant quantity (${maxQuantity}) is already in cart.`;
      } else if (variantError) {
        variantError.remove();
      }

      // If the current quantity exceeds the variant limit, correct it:
      if (cartQuantity > maxQuantity) {
        updateCartQuantity(variantId, maxQuantity);
      }
    });

    // After variant-level checks, enforce product-level constraints:
    updateProductConstraints();
  }

  // ── PRODUCT-LEVEL CONSTRAINTS (data-product-max) ─────────────────────────────
  // Group cart rows (by data-product-id) and sum quantities. If the total meets/exceeds
  // the allowed maximum (data-product-max), show an error (with limit) and disable UI actions.
  function updateProductConstraints() {
    const cartItems = document.querySelectorAll("tr.cart-item[data-product-id]");
    const productGroups = {};

    cartItems.forEach(item => {
      const productId = item.getAttribute("data-product-id");
      const maxAttr = item.getAttribute("data-product-max");
      const productMax = maxAttr && !isNaN(parseInt(maxAttr, 10))
                          ? parseInt(maxAttr, 10)
                          : Infinity;
      const input = item.querySelector("input.quantity__input");
      const quantity = parseInt(input.value, 10) || 0;

      if (!productGroups[productId]) {
        productGroups[productId] = { total: 0, max: productMax };
      }
      productGroups[productId].total += quantity;
    });

    const errorContainer = getErrorContainer();

    Object.keys(productGroups).forEach(productId => {
      const group = productGroups[productId];
      let prodError = errorContainer.querySelector(`.cart-error-message--product[data-product-id="${productId}"]`);
      if (group.total >= group.max) {
        if (!prodError) {
          prodError = document.createElement("div");
          prodError.className = "cart-error-message cart-error-message--product";
          prodError.setAttribute("data-product-id", productId);
          errorContainer.appendChild(prodError);
        }
        prodError.textContent = `Maximum Product Quantity (${group.max}) is already in cart.`;

        // Disable all plus buttons for rows in this product group:
        const matchingRows = document.querySelectorAll(`tr.cart-item[data-product-id="${productId}"]`);
        matchingRows.forEach(row => {
          const plusButton = row.querySelector("button[name='plus']");
          if (plusButton) {
            plusButton.classList.add("disabled");
            plusButton.setAttribute("disabled", "disabled");
            plusButton.setAttribute("data-product-disabled", "true");
          }
        });

        // Delay disabling the product form add-to-cart button by 1 second:
        setTimeout(() => {
          const addToCartButton = document.querySelector(".product-form__submit");
          if (addToCartButton) {
            addToCartButton.setAttribute("disabled", "disabled");
            addToCartButton.setAttribute("data-product-disabled", "true");
          }
        }, 1000);

      } else {
        if (prodError) {
          prodError.remove();
        }
        // Re-enable plus buttons if they were disabled by product-level constraint:
        const matchingRows = document.querySelectorAll(`tr.cart-item[data-product-id="${productId}"]`);
        matchingRows.forEach(row => {
          const plusButton = row.querySelector("button[name='plus']");
          if (plusButton && plusButton.getAttribute("data-product-disabled") === "true") {
            plusButton.removeAttribute("disabled");
            plusButton.classList.remove("disabled");
            plusButton.removeAttribute("data-product-disabled");
          }
        });
        // Re-enable the product form add-to-cart button if it was disabled:
        const addToCartButton = document.querySelector(".product-form__submit");
        if (addToCartButton && addToCartButton.getAttribute("data-product-disabled") === "true") {
          addToCartButton.removeAttribute("disabled");
          addToCartButton.removeAttribute("data-product-disabled");
        }
      }
    });
  }

  // ── DEBOUNCE ───────────────────────────────────────────────────────────────
  function debounce(fn, delay) {
    return function () {
      clearTimeout(updateTimeout);
      updateTimeout = setTimeout(fn, delay);
    };
  }

  const debouncedUpdateCartState = debounce(updateCartState, 1000);

  document.querySelectorAll("quantity-input input").forEach((input) => {
    input.addEventListener("change", debouncedUpdateCartState);
  });

  document.addEventListener("change", (event) => {
    if (event.target.matches("variant-selects input[type='radio']")) {
      debouncedUpdateCartState();
    }
  });

  debouncedUpdateCartState();
});

/* LAUNCH COUNTDOWN */
document.addEventListener('DOMContentLoaded', function () {
    function updateCountdown() {
        const products = document.querySelectorAll('.product-card-wrapper, .shopify-section--main-product');

        const now = new Date().getTime();

        products.forEach(product => {
            const badge = product.querySelector('.launch-date-badge');
            const buyButtonContainers = product.querySelectorAll('.product-form__buttons');
            const quickAddBulk = product.closest('.grid__item')?.querySelector('.quick-add-bulk');
            const quickAdd = product.closest('.grid__item')?.querySelector('.quick-add');

            if (!badge) return; // Skip if no launch badge

            const launchTimeAttr = badge.getAttribute('data-time');
            if (!launchTimeAttr) return; // Skip if no valid date-time

            const launchTime = new Date(launchTimeAttr).getTime();
            if (isNaN(launchTime)) return; // Skip if invalid date

            const distance = launchTime - now;

            if (distance > 0) {
                // Upcoming product
                const days = Math.floor(distance / (1000 * 60 * 60 * 24));
                if (days >= 1) {
                    badge.textContent = `Comes in ${days} day${days > 1 ? 's' : ''}`;
                } else {
                    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                    const seconds = Math.floor((distance % (1000 * 60 * 60)) / 1000);
                    badge.textContent = `Comes in ${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
                }

                // Disable buy buttons
                buyButtonContainers.forEach(container => {
                    const buyButton = container.querySelector('button');
                    if (buyButton) {
                        buyButton.textContent = 'Coming Soon';
                        buyButton.disabled = true;
                    }
                });

                // Hide quick-add-bulk and quick-add
                if (quickAddBulk) quickAddBulk.style.display = 'none';
                if (quickAdd) quickAdd.style.display = 'none';

            } else {
                // Product launched
                const daysPast = Math.floor(-distance / (1000 * 60 * 60 * 24));
                badge.textContent = daysPast <= 1 ? "Just Launched" : "";
                
                if (daysPast > 1) {
                    badge.remove();
                }

                // Enable buy buttons
                buyButtonContainers.forEach(container => {
                    const buyButton = container.querySelector('button');
                    if (buyButton) {
                        buyButton.textContent = 'ADD TO CART';
                        buyButton.disabled = false;
                    }
                });

                // Show quick-add-bulk and quick-add
                if (quickAddBulk) quickAddBulk.style.display = 'block';
                if (quickAdd) quickAdd.style.display = 'block';
            }
        });
    }

    // Initial update
    updateCountdown();

    // Update countdown every second
    const countdownInterval = setInterval(updateCountdown, 1000);

    // Clear interval when navigating away
    window.addEventListener('beforeunload', () => clearInterval(countdownInterval));
});

/* FLASH SALE */


$(document).ready(function() {

    var countdownElement = $('#flash-sale-countdown');

    if (countdownElement.length > 0) {
        var parseDateAsUTC = function(dateStr) {
            // Convert from GMT+7 to UTC
            var date = new Date(dateStr + 'Z');
            return new Date(date.getTime() - (7 * 3600000)); // Adjust from GMT+7 to UTC
        };

        var parseFlashSaleData = function(data) {
            var periods = data.split("*").filter(function(period) {
                return period.trim() !== '';
            }).map(function(period) {
                var parts = period.trim().split(" ");
                return {
                    startTime: parseDateAsUTC(parts[0] + ' ' + parts[1]),
                    endTime: parseDateAsUTC(parts[2] + ' ' + parts[3]),
                    recurrence: parts[4],
                    recurrenceEndDate: parseDateAsUTC(parts[5] + ' ' + parts[6])
                };
            });
            return periods;
        };

        var isSaleActive = function(period, now) {
            var start = new Date(period.startTime.getTime());
            var end = new Date(period.endTime.getTime());
            var recurrence = period.recurrence;

            switch (recurrence) {
                case 'daily':
                    start.setFullYear(now.getFullYear(), now.getMonth(), now.getDate());
                    end.setFullYear(now.getFullYear(), now.getMonth(), now.getDate());
                    break;
                case 'weekly':
                    var dayDiff = now.getDay() - start.getDay();
                    start = new Date(start.getTime() + dayDiff * 24 * 60 * 60 * 1000);
                    end = new Date(end.getTime() + dayDiff * 24 * 60 * 60 * 1000);
                    break;
                case 'monthly':
                    start.setMonth(now.getMonth());
                    end.setMonth(now.getMonth());
                    break;
                case 'one-time':
                    // No change needed for one-time events
                    break;
            }

         // Check against recurrence end date
            if (period.recurrence !== 'one-time' && now > period.recurrenceEndDate) {
                // Check if it's more than a day past the recurrence end date
                var recurrenceEndPlusOneDay = new Date(period.recurrenceEndDate.getTime() + ( 5 * 60 * 1000));
                if (now > recurrenceEndPlusOneDay) {
                    return false; // Sale period has ended
                }
            }


          
            return now >= start && now <= end;
        };

        var updateCountdown = function() {
    var nowUTC = new Date(new Date().toUTCString()); // Current UTC time
    var salePeriods = parseFlashSaleData(countdownElement.data('flash-sale'));
    var saleActive = false;
    var nextSaleStarts = null;

    for (var i = 0; i < salePeriods.length; i++) {
        var period = salePeriods[i];
        var start = new Date(period.startTime.getTime());
        var end = new Date(period.endTime.getTime());


         // Skip period if current time is past the recurrence end date
        if (period.recurrence !== 'one-time' && nowUTC > period.recurrenceEndDate) {
            // Check if it's more than a day past the recurrence end date
            var recurrenceEndPlusOneDay = new Date(period.recurrenceEndDate.getTime() + ( 5 * 60 * 1000));
            if (nowUTC > recurrenceEndPlusOneDay) {
                continue;
            }
        }

      
        // Adjust start and end times based on recurrence
        switch (period.recurrence) {
            case 'daily':
                start.setFullYear(nowUTC.getFullYear(), nowUTC.getMonth(), nowUTC.getDate());
                end.setFullYear(nowUTC.getFullYear(), nowUTC.getMonth(), nowUTC.getDate());
                break;
            case 'weekly':
                // Find the next occurrence of the sale
                while (start < nowUTC) {
                    start.setDate(start.getDate() + 7);
                    end.setDate(end.getDate() + 7);
                }
                break;
            case 'monthly':
                // Find the next occurrence of the sale
                while (start < nowUTC) {
                    start.setMonth(start.getMonth() + 1);
                    end.setMonth(end.getMonth() + 1);
                }
                break;
            // No adjustment needed for one-time events
        }

        // Check if the sale is currently active
        if (nowUTC >= start && nowUTC <= end) {
            var distanceToEnd = end - nowUTC;
            countdownElement.show();
            countdownElement.html("Flash Sale ends in: " + formatCountdown(distanceToEnd));
            saleActive = true;
            break;
        } else if (start > nowUTC) {
            if (!nextSaleStarts || start < nextSaleStarts) {
                nextSaleStarts = start;
            }
        }
    }

    // Display countdown to next sale if not currently active
    if (!saleActive && nextSaleStarts) {
        var distanceToStart = nextSaleStarts - nowUTC;
        if (distanceToStart <= 1 * 60 * 60 * 1000) { // Upcoming sale is within 1 hours
            countdownElement.show();
            countdownElement.html("Flash Sale starts in: " + formatCountdown(distanceToStart));
        } else {
           // countdownElement.html("Next Flash Sale Soon!");
        }
    } else if (!saleActive && !nextSaleStarts) {
    // If no upcoming sale and not currently active, hide the countdown
        clearInterval(interval);
        countdownElement.hide();
        var section = countdownElement.closest('.shopify-section');
if (section.length) {
    section.style.display = 'none';
}
      console.log('hide');
    } else if (!saleActive) {
        clearInterval(interval);
        countdownElement.html("Flash Sale Ended");
    }
};

        var formatCountdown = function(distance) {
            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);
            return days + "d " + hours + "h " + minutes + "m " + seconds + "s";
        };

        var interval = setInterval(updateCountdown, 1000);
        updateCountdown();

      var flashSaleCountdown = document.getElementById('flash-sale-countdown');
var shopifySection = flashSaleCountdown.closest('.shopify-section');

if (flashSaleCountdown && flashSaleCountdown.innerHTML.trim() === '') {
    if (shopifySection.length) {
        shopifySection.style.display = 'none';
    }
}
    }
});


document.addEventListener("DOMContentLoaded", function () {
    // Select all VIP/Invitation sections.
    const vipSections = document.querySelectorAll('.grid__item[data-invite-link="true"]');
    if (!vipSections.length) return; // Exit if no matching elements are found.

    // Retrieve the unique code from Shopify's settings.
    const element = document.querySelector('.grid__item[data-source]');
    if (element) {
        const uniqueValue = element.dataset.source;
        console.log(uniqueValue);
    }

    // Function to get a cookie's value by name.
    function getCookie(name) {
        const cookies = document.cookie.split('; ');
        for (let cookie of cookies) {
            const [key, value] = cookie.split('=');
            if (key === name) {
                return decodeURIComponent(value);
            }
        }
        return null;
    }

    // Retrieve the "invit" cookie.
    const invitCookieValue = getCookie('invit');

    // Validate the invitation link.
    if (invitCookieValue && uniqueValue && invitCookieValue === uniqueValue) {
        console.log('Invitation link is valid.');
        // Hide each VIP/Invitation section.
        vipSections.forEach(vipSection => {
            vipSection.style.display = 'block';
        });
    } else {
        console.log('Invalid invitation link.');
        // Show each VIP/Invitation section.
        vipSections.forEach(vipSection => {
            vipSection.style.display = 'none';
        });
    }
});





